export default async (context, { music }) => {
    await context.video_editor_click_video(context)

    context.musicActive = context.temporaryData.type !== 'music'

    if(context.musicActive) {
        context.buttonDelete = true
        context.temporaryData = music
        context.editElementStatus = true
    } else {
        context.temporaryData = false
        context.editElementStatus = false
    }
}